module.exports = __webpack_public_path__ + "img/2025-10-15d_1.941db3f5.jpg";